import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/dxb/Digital_footprint.webp";

function BannerText({ rtl }) {
  const className = rtl
    ? "revolution_gcc p-100 rtl-style"
    : "revolution_gcc p-100";
  return (
    <div className={className} style={{ backgroundImage: `url(${BannerImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              ، تيك ريفول في دبي – الانتشار في سوق دول مجلس التعاون الخليجي
            </h2>
            <p>
              افتتحات تيك ريفول مكاتب في الإمارة بغرض انتهاز فرص العمل ضمن سوق
              دول مجلس التعاون الخليجي وتأمين احتياجات قاعدة العملاء الكبيرة
              بواسطة أحدث التكنولوجيات والحلول الرقمية.
            </p>
            <p>
              في حين لا تتجاوز الأعمال التجارية المتقدمة في مسيرة التحول الرقمي
              في سوق المجلس 3%، توجد فرصة كبيرة لتلبية احتياجات الأعمال الناشئة
              والمتوسطة وتعزيز ريادتها.
            </p>
            <p>
              يرحب مكتبنا تيك ريفول بعد افتتاحه بجهود التعاون مع المؤسسات
              المختصة الجديدة في كامل القطاع وتبني الابتكارات المفتوحة.
            </p>
            <p>
              لا نسعى نحن في تيك ريفول كـ شركة تصميم تطبيقات الجوال في سوق
              المجلس إلى توفير الحلول الرقمية لكل عملائنا فحسب بل تزويدهم بحلول
              مستدامة ومرنة تتناسب مع فرص النمو وبالوقت ذاته الاستفادة من
              المشاريع الناشئة مثل ميتا فيرس والعملات الرمزية غير القابلة
              للاستبدال وسلاسل الكتل وغيرها.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              هيا بنا نبدأ
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BannerText;
